/* Package JSON Import will be here */
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
/* Package JSON Import will be here */

/* Project Import will be here */
import App from "./app/App";
import registerServiceWorker from "./registerServiceWorker";
import store from "./app/store";
import { history } from "./app/rootReducer";
/* Project Import will be here */

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root")
);

registerServiceWorker();